import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
} from "@chakra-ui/modal";
import { ClientSidebar } from "../ClientSidebar";

type Props = {
  isOpen: boolean;
  isTrialExpired: boolean;
  isSubscriptionDeactivated?: boolean;
  subscriptionType: string;
  onClose: () => void;
};

export const ClientMobileSidebar: React.FC<Props> = ({
  isOpen,
  isTrialExpired,
  isSubscriptionDeactivated,
  subscriptionType,
  onClose,
}) => {
  return (
    <Drawer
      isOpen={isOpen}
      placement="right"
      onClose={onClose}
      size={"xs"}
      isFullHeight={true}
    >
      <DrawerOverlay minH="100%" />
      <DrawerContent>
        <DrawerCloseButton />

        <DrawerBody pl="0px" pr="0px">
          <ClientSidebar
            //onlyHeader={false}
            isTrialExpired={isTrialExpired}
            handleDrawer={() => null}
            onCloseDrawer={onClose}
            isMobile={true}
            isSubscriptionDeactivated={isSubscriptionDeactivated}
            subscriptionType={subscriptionType}
          />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};
